import { omit } from '@luminovo/commons';
import * as React from 'react';
import type { JSX } from 'react';

import { Checkbox, CheckboxProps } from '../../Checkbox/Checkbox';
import { inputSlotWithRef } from '../FieldController/inputSlotWithRef';

export type FieldCheckboxProps = Omit<CheckboxProps, 'checked' | 'onChange'> & {
    value: boolean;

    onChange: (value: boolean) => void;

    onAfterChange?: (value: boolean) => void;

    /** react-hook-form's field ref, from `FieldController`. */
    inputRef?: React.Ref<HTMLInputElement>;
};

function FieldCheckboxInner(
    { value, onChange, onAfterChange, inputRef, slotProps, ...rest }: FieldCheckboxProps,
    outerRef: React.ForwardedRef<HTMLButtonElement>,
): JSX.Element {
    return (
        <Checkbox
            ref={outerRef}
            checked={value}
            onChange={(_, value) => {
                onChange(value);
                onAfterChange?.(value);
            }}
            slotProps={{ ...slotProps, input: inputSlotWithRef(slotProps?.input, inputRef) }}
            {...omit(rest, 'error', 'helperText')}
        />
    );
}

export const FieldCheckbox = React.forwardRef(FieldCheckboxInner) as (
    props: FieldCheckboxProps & { ref?: React.ForwardedRef<HTMLButtonElement> },
) => JSX.Element;
